module.exports = __webpack_public_path__ + "static/Report-Hybrid-7e75f85042c0afdcafed24c3e1cfdc83.webp";